import { Injectable } from "@angular/core";
import { AssetInfoModel, CollectionInfoModel, PhdsoftCommonService, RegionItem, Util } from "@phdsoft/common";
import { COLLECTIONIDSCONSTANTS } from "projects/phdsoft/common/src/lib/shared/constants/collectionIds";
import { ELEMENTSTYPESIDS } from "projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { MeshoptDecoder } from 'meshoptimizer';
import * as THREE from '@phdsoft/three';
import { Collection } from "src/app/platform/busines-data/Campaigns/Collection";
import { DocumentsCollection } from "src/app/platform/busines-data/Campaigns/document-collection";
import { InspectionCampaign } from "src/app/platform/busines-data/Campaigns/InspectionCampaign";
import { StructureCollection } from "src/app/platform/busines-data/Campaigns/StructureCollection";
import { Asset } from "src/app/platform/busines-data/Framework/Asset";
import { Region } from "src/app/platform/busines-data/Framework/Region";
import { Section } from "src/app/platform/busines-data/Framework/Section";
import { SteelThicknessGaugingPoint } from "src/app/platform/busines-data/SectionElements/InspectionElements/steelThicknessGaugingPoint";
import { LinearElement } from "src/app/platform/busines-data/SectionElements/StructureElements/LinearElement";
import { StructuralElement } from "src/app/platform/busines-data/SectionElements/StructureElements/StructuralElement";
import { SurfaceElement } from "src/app/platform/busines-data/SectionElements/StructureElements/SurfaceElement";
import { AssetInfoViewService } from "src/app/template/asset-info-view/asset-info-view/asset-info-view.service";
import { Graphics } from "../graphics/graphics";
import { GraphicsMaterials } from "../graphics/graphics-materials";
import { MaHGLTFLoader } from "../Three/MaHGLTFLoader";
import { CameraControl } from "../graphics/graphics-camera-controler.service"
import { BehaviorSubject } from "rxjs";
import { SensorCollection } from "src/app/platform/busines-data/Campaigns/SensorCollection";
import { AssetManager } from "src/app/asset-manager/asset-manager";
import { MatSnackBar } from '@angular/material/snack-bar';
import { CollectionStaticData } from "src/app/collections/_utils/collection.static.data";
import { AssetManagerSensors } from "src/app/asset-manager/asset-manager-sensors";
import { AssetService } from "src/app/shared/services/asset.service";
import { ElementTypesService } from "src/app/admin/services/element-types.service";
import { INSPECTIONS_TYPES_IDS } from "projects/phdsoft/common/src/lib/shared/constants/inspections-types-ids";
import { LightStructureCollection } from "src/app/platform/busines-data/Campaigns/LightStructureCollection";
import { AnomalyService } from "src/app/admin/services/anomaly.service";
import { v4 as uuid } from 'uuid';
import { INSERTIONCONSTANTS } from "projects/phdsoft/common/src/lib/shared/constants/insertions-constants";
import { ChangesWorkflowService } from "src/app/template/changes-workflow/changes-workflow.service";
import { RegionsService } from 'src/app/admin/services/regions.service'
import { TemporalCollection } from "src/app/platform/busines-data/Campaigns/TemporalCollection";
import { CullingService } from '../graphics/culling/culling.service';
import { LightSectionModRenderer } from './LightSectionModRenderer';
import { addCampaignRegion } from './campaign-region-scaffold';
import { GeometricElement } from "src/app/platform/busines-data/GeometricSurfaceElement";
import { SectionBorderSettings } from "src/app/platform/busines-data/Framework/section-border-settings";
import { createLightModelEdgesWorker, LightModelEdges } from "./light-model-edges";

@Injectable({ providedIn: 'root' })
export class AssetLoader {

    private manager: THREE.LoadingManager;
    private gltfLoader: MaHGLTFLoader;
    private dracoLoader: DRACOLoader;
    private assetInfo: AssetInfoModel;
    private bbox: THREE.Box3;
    public gltfLoadedItems = 0;
    public gltfLoadedTotal = 0;
    public gltfLoadedParts = '';
    public progressValue = 0;
    public blobPathsLength = 0;
    public blobPathsLoaded: number = 0;
    public gltfLoadedPercentual: number = 0;
    private assetProgressBarPercent = new BehaviorSubject<number>(1);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    // Inspection campaign(s) created by loadAsset; loadNewRegion adds each loaded region to them
    private loadTimeInspectionCampaigns: InspectionCampaign[] = [];
    /** Light-model crease edges of the current asset (see LightModelEdges); null without a light model. */
    private lightModelEdges: LightModelEdges | null = null;
    private oldAssetIds = [
        "0683497e4e9340b89b15a8c5da83fd82", //Crane 212
        "116fb20d4026460ebe140d5837eefc47", //Tunel
        "5fe448e431b04fee890ed64a8e6b979a", //Tunel 2
        "2b10065789794a449d7cd5c97b878a27" //Tunel 2
    ]


    castAssetProgressBarPercent = this.assetProgressBarPercent.asObservable();

    getProgressPercent(currentPercent: number) {
        this.assetProgressBarPercent.next(currentPercent)
    }

    setProgressStopValue(progressEndValue: number) {

    }

    interval2finishRemake(progressEndValue: number, speed: number) {
        const interval = setInterval(() => {
            this.progressValue++;
            this.getProgressPercent(this.progressValue);
            if (this.progressValue >= progressEndValue) {
                clearInterval(interval)
            }
        }, speed)
    }

    constructor(
        private phdsoftCommonService: PhdsoftCommonService,
        private graphics: Graphics, private graphicsMaterials: GraphicsMaterials,
        private cameraControl: CameraControl,
        private assetInfoViewService: AssetInfoViewService,
        private assetManager: AssetManager,
        private snackbar: MatSnackBar,
        private assetManagerSensors: AssetManagerSensors,
        private assetService: AssetService,
        private elementTypesService: ElementTypesService,
        private anomalyService: AnomalyService,
        public readonly changesWorkflowService: ChangesWorkflowService,
        private regionsService: RegionsService,
        private cullingService: CullingService,
        private lightSectionModRenderer: LightSectionModRenderer,
            ) {
        this.bbox = new THREE.Box3();
    }

    private setLoading(isLoading: boolean) {
        this.loadingSubject.next(isLoading);
    }

    public async loadAsset(assetInfo: AssetInfoModel): Promise<Asset> {
        this.graphics.init(0, 0, 1, false);
        this.graphics.animate();

        SteelThicknessGaugingPoint.emptyValueMaterial = GraphicsMaterials.pointMaterial;
        SteelThicknessGaugingPoint.acceptableCorrosionMaterial = GraphicsMaterials.pointMaterialGreen;
        SteelThicknessGaugingPoint.substantialCorrosionMaterial = GraphicsMaterials.pointMaterialYellow;
        SteelThicknessGaugingPoint.excessiveCorrosionMaterial = GraphicsMaterials.pointMaterialRed;
        SteelThicknessGaugingPoint.overThicknessMaterial = GraphicsMaterials.pointMaterialBlack;

        StructuralElement.acceptableCorrosionMaterial = GraphicsMaterials.acceptableCorrosionViewModeMaterial;
        StructuralElement.substantialCorrosionMaterial = GraphicsMaterials.substantialCorrosionViewModeMaterial;
        StructuralElement.excessiveCorrosionMaterial = GraphicsMaterials.excessiveCorrosionViewModeMaterial;

        const _asset = new Asset(this.graphics);
        // "Show section borders" for this load: the stored value (missing/unreadable → true)
        SectionBorderSettings.reload();
        // The previous asset's light-model edges: terminate its worker, ignore a late answer
        this.disposeLightModelEdges();
        this.lightSectionModRenderer.reset();
        _asset.lightSectionModRenderer = this.lightSectionModRenderer;

        // Occlusion culling: every section of every structure region (never the light
        // model campaign). Registered before the first region load so the rebuild()
        // after each newLoadScene already wraps the loaded sections.
        this.cullingService.setSectionProvider(
            () => _asset.GetAllStructureRegions().flatMap(region => region.sections ?? []),
            () => _asset.isNewModelMode
        );

        this.graphics.addToScene(_asset.group);
        this.graphics.addToCssScene(_asset.cssGroup);

        this.assetInfo = assetInfo;

        _asset.assetInfo = assetInfo;
        _asset.setMaterials(assetInfo.Materials);
        _asset.setThicknessColorTable(assetInfo.ThicknessColorTable);
        this.graphicsMaterials.createMaterialMaterials(_asset.materials);
        this.graphicsMaterials.createThicknessTableMaterials(_asset.thicknessColorTable);
        this.graphicsMaterials.createRegionsMaterials(assetInfo.Regions);
        await this.createLoaders();

        //webworker
        this.bbox = new THREE.Box3()
        let collection = this.assetInfo.Collections.filter(x => x.Type === COLLECTIONIDSCONSTANTS.STRUCTURE);
        const _structureCampaign = new StructureCollection(collection[0].Date);
        _asset.Campaigns = new Array<Collection>();
        _asset.TemporalCampaigns = new Array<TemporalCollection>();
        _asset.Campaigns.push(_structureCampaign);
        const missingRegions = await this.loadStructureGeometry(_asset, collection, _structureCampaign);

        let allAssetSctructureGroups = _asset.GetAllStructureRegions()

        this.assetManager.asset = _asset;
        if (allAssetSctructureGroups.length > 0) {
            this.assetInfoViewService.setRegionAndSections(allAssetSctructureGroups);
            _asset.Campaigns.push(this.createResourceCampaigns(allAssetSctructureGroups));
            _asset.addCollection(this.createSensorCampaign(_asset.Campaigns[0].Date, allAssetSctructureGroups));
            // was: _asset.addCollection(this.createInspectionCampaign(_asset.Campaigns[0].Date, allAssetSctructureGroups));
            const inspectionCampaign = this.createInspectionCampaign(_asset.Campaigns[0].Date, allAssetSctructureGroups);
            _asset.addCollection(inspectionCampaign);
            this.loadTimeInspectionCampaigns = [inspectionCampaign];
        }
        else{
            allAssetSctructureGroups = _asset.GetLightModelRegions();
            _asset.GetLightModelMissingRegions(missingRegions);
            this.assetInfoViewService.setRegionAndSections(allAssetSctructureGroups);
            // Documents need every region up front: getAssetDocuments runs once and drops
            // the documents of regions it cannot find.
            _asset.Campaigns.push(this.createResourceCampaigns(allAssetSctructureGroups));
            // Sensor and inspection start empty: an empty Region + Section per light-model
            // region is ≈16k empty Object3Ds per campaign, walked every frame. Each region is
            // added when it loads (ensureLoadedRegionInCampaigns, from loadNewRegion).
            // was: _asset.addCollection(this.createSensorCampaign(_asset.Campaigns[0].Date, allAssetSctructureGroups));
            // was: _asset.addCollection(this.createInspectionCampaign(_asset.Campaigns[0].Date, allAssetSctructureGroups));
            _asset.addCollection(this.createSensorCampaign(_asset.Campaigns[0].Date, []));
            const inspectionCampaign = this.createInspectionCampaign(_asset.Campaigns[0].Date, []);
            _asset.addCollection(inspectionCampaign);
            this.loadTimeInspectionCampaigns = [inspectionCampaign];
        }

        if (_asset.isLightModel) this.loadRegionsAnomalies(_asset.assetInfo.Regions);

        _asset.box3 = this.bbox;

        if (navigator.onLine) {
            this.assetManagerSensors.loadSensors();
            this.elementTypesService.getAssetElementsAndProperties(this.assetManager.asset.assetInfo.AssetId).subscribe((responses) => {
                this.assetManager.assetProperties = responses[0]
                this.assetManager.assetCompositeProperties = responses[1]
                this.assetManager.assetElementTypes = responses[2]
                this.assetManager.assetCompositePropertiesValues = responses[3]
            })

            this.loadChanges()
        }

        this.cameraControl.setParameters(this.graphics.Controls, this.graphics.Camera);
        this.cameraControl.setCameraPosition(this.bbox);

        // First load goes through the same MODEL state as a return to MODEL
        this.applyInitialModelState(_asset);

        // Build the occlusion-culling sections (section proxies) after the asset is fully loaded
        // was: this.cullingService.build(_asset.group, _asset.isNewModelMode);
        // was: this.cullingService.build(_asset.GetAllStructureRegions().flatMap(region => region.sections ?? []), _asset.isNewModelMode);
        // — same sections and mode as the provider registered above, so rebuild through it.
        this.cullingService.rebuild();

        return Promise.resolve(_asset);
    }

    /**
     * New format without a light model: apply the MODEL state (Section.setViewOnModelMode) to
     * every structure region. newLoadScene adopts the GLTF Borders group with its default
     * visible = true; this makes it follow the "show section borders" setting, like every
     * route back to MODEL does. Old format and light-model assets are left as loaded.
     */
    private applyInitialModelState(asset: Asset): void {
        if (!asset.isNewModelMode || asset.isLightModel) return;
        asset.GetAllStructureRegions().forEach(region => region.setViewOnModelMode());
    }

    public loadRegionsAnomalies(regions :RegionItem[]) {
        this.assetManager.asset.anomalies = [];
        for (var region of regions)
        {
            this.anomalyService.getAnomalyList(region.assetId, region.id).then(anomalies =>
                this.assetManager.asset.anomalies.concat(anomalies)
            );
        }
    }

    public async addGltfFile(asset: Asset, file: File) {
        const reader = new FileReader();
        reader.addEventListener('load', async (e) => {
            let data = e.target.result;
            const gltfData = await this.modelLoader(data);
            this.loadElements(gltfData, asset.StructureCampaigns[0]);
            this.blobPathsLoaded++;
        });
        reader.readAsArrayBuffer(file);
    }

    async filterSelectedRegions(assetInfo: AssetInfoModel): Promise<AssetInfoModel> {
        if (!Util.isNullOrUndefined(assetInfo?.Regions)) {
            // Save all region ids for future reference
            let allRegionIds = assetInfo?.Regions?.map(x => {
                return { id: x.id }
            });
            assetInfo.RegionsIdsReference = JSON.parse(JSON.stringify(allRegionIds));

            // Filter Regions
            let selectedRegions = assetInfo?.Regions?.filter(item => item.selected);

            assetInfo.Regions = JSON.parse(JSON.stringify(selectedRegions));
            selectedRegions = null;
            const regionIds = assetInfo.Regions.flatMap(r => r.id);
            const collectionsAssetInfo = assetInfo.Collections;
            assetInfo.Collections = assetInfo.Collections.filter(c => c.Type !== COLLECTIONIDSCONSTANTS.INSPECTION);
            assetInfo.Collections = assetInfo?.Collections.filter(col =>
                col.BlobPaths = col.BlobPaths.filter(blob =>
                    regionIds.includes(blob.RegionId)
                )) as any;
            const selectedRegionSections =
                assetInfo.Sections.filter(sec => sec.regions.filter(regId => regionIds.includes(regId)));
            assetInfo.Sections = JSON.parse(JSON.stringify(selectedRegionSections));
        }
        return JSON.parse(JSON.stringify(assetInfo));
    }

    public async loadNewRegion(regionId:string): Promise<Asset> {
        this.setLoading(true);
        if(!this.verifyBlobRegionLoaded(regionId)){
            let currentAsset: any = await this.assetService.getCurrentAsset(this.assetInfo.AssetId);

            this.assetManager.asset.assetInfo = currentAsset.AssetInfo
            this.assetInfo = currentAsset.AssetInfo
        }


        // Add workable elements
        // Check if this.assetManager.asset.StructureCampaigns[0] has region.workableElement in order to not load again
        if (Util.isNullOrUndefined(this.assetManager.asset.StructureCampaigns[0].regionsWorkableElements.find(item => item.Guid === regionId))) {
            await this.addWorkableElements(
                this.assetManager.asset.assetInfo.Collections.filter(x => x.Type === COLLECTIONIDSCONSTANTS.STRUCTURE)[0],
                this.assetManager.asset.StructureCampaigns[0],
                regionId
            )
        }
        // Before DTSelectionService.setSelectRegion, which resolves currentRegion from these campaigns
        this.ensureLoadedRegionInCampaigns(regionId);
        //this.cameraControl.setCameraPosition(this.bbox);
        this.setLoading(false);
        this.assetManager.updateViewMode()
        return Promise.resolve(this.assetManager.asset);
    }

    /**
     * Gives a loaded structure region its (empty) sensor and load-time inspection
     * scaffolding. Light-model assets build those campaigns empty; for every other
     * asset the region is already there and this is a no-op.
     */
    private ensureLoadedRegionInCampaigns(regionId: string): void {
        const asset = this.assetManager.asset;
        const region = asset.StructureCampaigns[0].regionsWorkableElements.find(r => r.Guid === regionId);
        if (!region) return;
        addCampaignRegion(asset.SensorCampaign, region, { css: true });
        for (const campaign of this.loadTimeInspectionCampaigns) addCampaignRegion(campaign, region, { css: false });
    }

    private verifyBlobRegionLoaded(regionId:string){
        return this.assetInfo?.Collections[0]?.BlobPaths?.findIndex(x => x.RegionId === regionId) > -1;
    }

    async addWorkableElements(collectionInfo: CollectionInfoModel, structureCollection: StructureCollection, regionId: string): Promise<Array<THREE.Group>> {
        const groups = new Array<THREE.Group>();
        for (const blobRegion of collectionInfo.BlobPaths) {
            if (blobRegion.RegionId === regionId) {
                const structureGroup = new THREE.Group();
                structureGroup.name = blobRegion.RegionId;
                structureGroup.userData.RegionIds = blobRegion.RegionIds;
                structureGroup.userData.CollectionId = collectionInfo.CollectionId;
                this.setSectionGroups(structureCollection, blobRegion.RegionId);
                if (blobRegion.RenderGeoPath) {
                  if (window.navigator.onLine) {
                    groups.push(await this.loadGroupRegion(blobRegion.RenderGeoPath, structureCollection, blobRegion.RegionId, undefined, this.assetManager.asset));
                  } else {
                    groups.push(await this.loadOfflineGroupRegion(blobRegion.RenderGeoPath, structureCollection, blobRegion.RegionId, this.assetManager.asset));
                  }
                }
            }
        }
        return groups;
    }

    /**
     * Loads the asset's structure geometry.
     *
     * Assets with a light model and enough regions load the single light-model
     * GLTF; every other asset loads its regions one by one through the structure
     * campaigns. When the light-model blob cannot be fetched (bad stored path,
     * expired SAS, 404) the loader logs the error and falls back to the
     * per-region path instead of aborting `loadAsset` — an aborted load is caught
     * by the digital-twin page and sends the user back to the login screen.
     *
     * @returns the regions that have no structure blob (light-model path only).
     */
    private async loadStructureGeometry(
        _asset: Asset,
        collection: Array<CollectionInfoModel>,
        _structureCampaign: StructureCollection,
    ): Promise<Array<RegionItem>> {
        // Initial load: skip the per-region culling rebuilds (each re-wrapped and re-measured
        // every section loaded so far); loadAsset's final cullingService.rebuild() wraps all.
        this.cullingService.deferRebuilds(true);
        try {
            return await this.loadStructureGeometryRegions(_asset, collection, _structureCampaign);
        } finally {
            this.cullingService.deferRebuilds(false);
        }
    }

    private async loadStructureGeometryRegions(
        _asset: Asset,
        collection: Array<CollectionInfoModel>,
        _structureCampaign: StructureCollection,
    ): Promise<Array<RegionItem>> {
        const missingRegions: Array<RegionItem> = [];
        if (_asset.assetInfo.LightModelPath && _asset.assetInfo.Regions.length >= 5) {
            _asset.isLightModel = true;
            _asset.lightCampaign = new LightStructureCollection(new Date());
            for (const region of _asset.assetInfo.Regions) {
                this.setSectionGroups(_asset.lightCampaign, region.id);
                const index = this.assetInfo.Collections[0].BlobPaths.findIndex(x => x.RegionId === region.id);
                if (index === -1) {
                    missingRegions.push(region);
                }
            }
            try {
                await this.loadLightModel(_asset);
                _asset.group.add(_structureCampaign.group);
                return missingRegions;
            } catch (error) {
                console.error('Light model could not be loaded; falling back to per-region loading.', error);
                _asset.isLightModel = false;
                _asset.lightCampaign = null;
            }
        }
        await this.loadCampaigns(_asset, collection, this.graphics.scene, _structureCampaign);
        return [];
    }

    async loadLightModel(_asset: Asset): Promise<void> {
        if (!Util.isNullOrUndefined(_asset.assetInfo.LightModelPath)) {
            try {
                const gltfFile: any = await this.phdsoftCommonService.getFileArrayBuffer(_asset.assetInfo.LightModelPath, !window.navigator.onLine);
                const gltfData: any = await this.modelLoader(gltfFile);
                this.loadElements(gltfData, _asset.lightCampaign);
                this.blobPathsLoaded++;
                _asset.group.add(_asset.lightCampaign.group);
                // Crease edges computed off the main thread; they appear when ready, the load does not wait
                this.startLightModelEdges(_asset);
            } catch (error) {
                console.error("Error loading light model:", error);
                throw error;
            }
        }
    }

    /** Starts the worker build of the light model's crease edges (any failure: warning, no edges). */
    private startLightModelEdges(_asset: Asset): void {
        this.disposeLightModelEdges();
        const group = _asset.lightCampaign?.group;
        if (!group) return;
        try {
            const edges = new LightModelEdges(
                GraphicsMaterials.lightModelEdgeMaterial,
                createLightModelEdgesWorker,
                () => SectionBorderSettings.show,
                () => this.graphics?.requestRender(),
            );
            this.lightModelEdges = edges;
            _asset.lightModelEdges = edges;
            edges.build(group);
        } catch (error) {
            console.warn('Light model edges could not be started; no edges drawn.', error);
        }
    }

    private disposeLightModelEdges(): void {
        this.lightModelEdges?.dispose();
        this.lightModelEdges = null;
    }

    private loadChanges() {
      this.changesWorkflowService.getAllChanges(this.assetManager.asset.assetInfo.AssetId).subscribe(result => {
        this.assetManager.assetChanges = result
      })
    }

    //webworker
    private async loadCampaigns(asset: Asset, campaigns: Array<CollectionInfoModel>, scene: THREE.Scene, _structureCampaign:StructureCollection): Promise<void> {

        this.blobPathsLength = this.numberOfFilesToLoad(campaigns)
        this.interval2finishRemake(80, this.blobPathsLength * 100)
        for (const collection of campaigns) {
            // _structureCampaign.group = new THREE.Group();
            // _structureCampaign.Date = new Date(collection.Date);

            asset.group.add(_structureCampaign.group);

            await this.loadGroups(collection, scene, _structureCampaign, asset?.assetInfo?.AssetId, asset);
        }
    }

    private numberOfFilesToLoad(collections: Array<CollectionInfoModel>): number {
        return collections.reduce((a, b) => a + b.BlobPaths.length, 0);
    }

    //webworker
    private async loadGroups(collectionInfo: CollectionInfoModel, scene: THREE.Scene, structureCollection: StructureCollection, assetId?: string, asset?: Asset): Promise<Array<THREE.Group>> {
        const groups = new Array<THREE.Group>();
        for (const blobRegion of collectionInfo.BlobPaths) {
            const structureGroup = new THREE.Group();
            structureGroup.name = blobRegion.RegionId;
            structureGroup.userData.RegionIds = blobRegion.RegionIds;
            structureGroup.userData.CollectionId = collectionInfo.CollectionId;

            this.setSectionGroups(structureCollection, blobRegion.RegionId);

            if (blobRegion.RenderGeoPath) {
                if (window.navigator.onLine) {
                    groups.push(await this.loadGroupRegion(blobRegion.RenderGeoPath, structureCollection, blobRegion.RegionId, assetId, asset));
                } else {
                    groups.push(await this.loadOfflineGroupRegion(blobRegion.RenderGeoPath, structureCollection, blobRegion.RegionId, asset));
                }
            }
        }
        return groups;
    }
    private async loadGroupRegion(path: string, structureCollection: StructureCollection, regionId?: string, assetId?: string, asset?: Asset): Promise<THREE.Group> {
        const _group = new THREE.Group();

        if (!Util.isNullOrUndefined(path)) {
            // const gltfFile: any = await this.phdsoftCommonService.getFileArrayBuffer(path, !window.navigator.onLine);
            // const gltfData = await this.modelLoader(gltfFile);
            // this.loadElements(gltfData, structureCollection)
            // this.blobPathsLoaded++;

            try {
                // const gltfFile: any = await this.phdsoftCommonService.getFileArrayBuffer(
                //   path,
                //   !window.navigator.onLine,
                // )
                let fileLink = null;

                if (!assetId || !this.oldAssetIds.includes(assetId)) {
                    fileLink = this.extractHexValues(path);
                }
                if (this.oldAssetIds.includes(assetId)) {
                    fileLink = {
                        regionId: regionId,
                        sectionId: regionId
                    };
                }



                const res = await this.regionsService
                    .getEncryptedRegion(this.assetInfo.AssetId, fileLink.sectionId)
                    .toPromise()
                if (res) {
                    const gltfData: any = await this.modelLoader(res)
                    const isNewFormat = gltfData.asset?.generator?.includes('glTF-Transform')
                        || gltfData.scene?.children?.[0]?.userData?.isNewGltf;
                    if (isNewFormat) {
                        this.newLoadScene(gltfData, structureCollection, regionId);
                        if (asset) {
                            asset.isNewModelMode = true;
                        }
                        // Wrap the region's sections in culling proxies (after newLoadScene returned)
                        this.cullingService.rebuild();
                    } else {
                        this.loadElements(gltfData, structureCollection)
                    }
                    this.blobPathsLoaded++
                } else {
                    console.log('No data returned from getEncRegion')
                }
            } catch (error) {
                console.error('Error in loadGroupRegion:', error)
            }
        }
        return _group;
    }

    private async loadOfflineGroupRegion(path: string, structureCollection: StructureCollection, regionId?: string, asset?: Asset): Promise<THREE.Group> {
        const _group = new THREE.Group();

        if (!Util.isNullOrUndefined(path)) {
            const gltfFile: any = await this.phdsoftCommonService.getFileArrayBuffer(path, !window.navigator.onLine);
            const gltfData: any = await this.modelLoader(gltfFile);
            const isNewFormat = gltfData.asset?.generator?.includes('glTF-Transform')
                || gltfData.scene?.children?.[0]?.userData?.isNewGltf;
            if (isNewFormat) {
                this.newLoadScene(gltfData, structureCollection, regionId);
                if (asset) {
                    asset.isNewModelMode = true;
                }
                // Wrap the region's sections in culling proxies (after newLoadScene returned)
                this.cullingService.rebuild();
            } else {
                this.loadElements(gltfData, structureCollection)
            }
            this.blobPathsLoaded++;
        }
        return _group;
    }

    private modelLoader(gltfFile) {
        return new Promise((resolve, reject) => {
            this.gltfLoader.loadOffline(gltfFile, data => resolve(data), null, reject);
        })
    }

    private loadElements(gltf, structureCollection: StructureCollection): void {
        for (let index = gltf.scene.children.length - 1; index >= 0; index--) {
            this.getMeshesRecursive(gltf.scene.children[index], structureCollection);
        }
    }

    /**
     * Load new GLTF scene graph structure:
     * Region Group > Section Group > {SurfaceElements, LinearElements, Borders, LightSection}
     *
     * Replaces the entire region.group and section.group with the GLTF groups
     * to preserve transforms from the GLTF hierarchy.
     */
    private newLoadScene(gltf: any, structureCollection: StructureCollection, regionId: string): void {
        const gltfRegionGroup = gltf.scene.children[0] as THREE.Group;
        if (!gltfRegionGroup) return;

        // DEBUG: Print the scene graph skeleton of gltfRegionGroup
        // console.log('\n=== GLTF Region Scene Graph Skeleton ===\n' + this.buildSceneGraphSketch(gltfRegionGroup));

        const region = structureCollection.regionsWorkableElements.find(x => x.Guid === regionId);
        if (!region) {
            console.warn('newLoadScene: region not found for id', regionId);
            return;
        }

        // Replace region.group with GLTF region group (preserves transforms)
        region.group.removeFromParent();
        region.group = gltfRegionGroup;
        structureCollection.group.add(region.group);

        // For each section, replace section.group with the GLTF section group
        for (const section of region.sections) {
            const sectionGltfGroup = region.group.children.find(
                x => x.name === section.Guid
            ) as THREE.Group;

            if (!sectionGltfGroup) {
                continue;
            }

            section.group.removeFromParent();

            // Extract named child groups from the GLTF section
            section.borderGroup = (sectionGltfGroup.children.find(
                x => x.name.includes("Borders")
            ) as THREE.Group) ?? new THREE.Group();
            section.surfaceGroup = (sectionGltfGroup.children.find(
                x => x.name.includes("SurfaceElements")
            ) as THREE.Group) ?? new THREE.Group();
            section.linearGroup = (sectionGltfGroup.children.find(
                x => x.name.includes("LinearElements")
            ) as THREE.Group) ?? new THREE.Group();
            section.lightSectionGroup = (sectionGltfGroup.children.find(
                x => x.name.includes("LightSection")
            ) as THREE.Group) ?? new THREE.Group();

            // Replace section.group with GLTF group
            section.group = sectionGltfGroup;

            // Set initial visibility
            section.surfaceGroup.visible = false;
            section.linearGroup.visible = false;

            // Ensure groups are parented (some may not be direct children in GLTF)
            if (!section.borderGroup.parent) section.group.add(section.borderGroup);
            if (!section.surfaceGroup.parent) section.group.add(section.surfaceGroup);
            if (!section.linearGroup.parent) section.group.add(section.linearGroup);
            if (!section.lightSectionGroup.parent) section.group.add(section.lightSectionGroup);

            // Apply materials to LightSection meshes
            section.setLightSectionMaterial();
            this.lightSectionModRenderer.registerLightSectionMeshes(regionId, section.Guid, section.lightSectionGroup);

            // Elements with a custom material are masked out of the merged
            // lightsection and rendered as overlays in REGIONS mode (repairs pattern)
            const customMaterialElements: GeometricElement[] = [];

            // Register surface elements (addToGroup=false, already in GLTF hierarchy)
            section.surfaceGroup?.traverse(obj => {
                if (obj instanceof THREE.Mesh) {
                    this.fixElementType(obj);
                    const element = this.registerElementFromMesh(obj, structureCollection, false);
                    if (element?.customMaterial) customMaterialElements.push(element);
                }
            });

            // Register linear elements
            section.linearGroup?.traverse(obj => {
                if (obj instanceof THREE.Mesh) {
                    this.fixElementType(obj);
                    const element = this.registerElementFromMesh(obj, structureCollection, false);
                    if (element?.customMaterial) customMaterialElements.push(element);
                }
            });

            this.lightSectionModRenderer.registerCustomMaterialElements(regionId, section.Guid, customMaterialElements, section.group);

            // Expand bounding box
            let meshCount = 0;
            section.group.traverse(obj => {
                if (obj instanceof THREE.Mesh) {
                    meshCount++;
                    this.bbox.expandByObject(obj);
                }
            });
        }

        // console.log('\n=== GLTF Region Scene Graph Skeleton ===\n' + this.buildSceneGraphSketch(region.group));
    }

    /** Debug helper: dump object hierarchy */
    private getHierarchy(obj: THREE.Object3D, depth = 0): any {
        if (!obj) return null;
        if (depth > 4) return '...';
        return {
            name: obj.name,
            type: obj.type,
            visible: obj.visible,
            children: obj.children?.map(c => this.getHierarchy(c, depth + 1))
        };
    }

    /**
     * Debug helper: build a sketch-style scene graph string.
     * Each structural level appears only once (first representative child).
     * Leaf meshes/lines are tallied by type.
     * Returns the full tree as a single string (use with one console.log).
     */
    private buildSceneGraphSketch(root: THREE.Object3D, indent: string = '', depth: number = 0): string {
        const lines: string[] = [];
        const maxDepth = 10;
        if (depth > maxDepth) {
            lines.push(`${indent}... (max depth ${maxDepth} reached)`);
            return lines.join('\n');
        }

        // userData tag
        let tag = '';
        if (root.userData) {
            const ud = root.userData;
            if (ud.isNewGltf !== undefined) tag += `, userData.isNewGltf: ${ud.isNewGltf}`;
        }

        const childCount = root.children?.length ?? 0;
        const isLeaf = root.type === 'Mesh' || root.type === 'LineSegments' || root.type === 'Line';
        const pipe = depth === 0 ? '' : '├── ';

        if (isLeaf) {
            const geo = (root as THREE.Mesh).geometry as THREE.BufferGeometry;
            const geoType = (geo as any)?.type || geo?.constructor?.name || '?';
            lines.push(`${indent}${pipe}${root.type} (name: "${root.name}", ${geoType})${tag}`);

            // If this mesh has children, recurse into them
            if (childCount > 0) {
                const meshChildIndent = indent + '│   ';
                const subGroups = root.children.filter(c => c.type === 'Group' || c.type === 'Object3D');
                const subLeaves = root.children.filter(c => c.type !== 'Group' && c.type !== 'Object3D');

                for (const g of subGroups) {
                    lines.push(this.buildSceneGraphSketch(g, meshChildIndent, depth + 1));
                }

                // Tally direct mesh/line children
                if (subLeaves.length > 0) {
                    const hasGrandchildren = subLeaves.some(c => (c.children?.length ?? 0) > 0);
                    if (hasGrandchildren) {
                        // Some sub-leaves also have children — show them individually
                        for (const child of subLeaves) {
                            lines.push(this.buildSceneGraphSketch(child, meshChildIndent, depth + 1));
                        }
                    } else {
                        const tally = new Map<string, number>();
                        for (const child of subLeaves) {
                            const label = child.userData?.Type || child.name || child.type;
                            const key = `${label} (${child.type})`;
                            tally.set(key, (tally.get(key) ?? 0) + 1);
                        }
                        const parts = Array.from(tally.entries()).map(([k, v]) => `${v}× ${k}`);
                        lines.push(`${meshChildIndent}├── [ ${parts.join(', ')} ]`);
                    }
                }
            }

            return lines.join('\n');
        }

        // Group / Object3D
        lines.push(`${indent}${pipe}${root.type} (name: "${root.name}")${tag}`);
        if (!root.children || childCount === 0) return lines.join('\n');

        const childIndent = depth === 0 ? '  ' : indent + '│   ';
        const groups = root.children.filter(c => c.type === 'Group' || c.type === 'Object3D');
        const leaves = root.children.filter(c => c.type !== 'Group' && c.type !== 'Object3D');

        // Show only ONE representative for each "kind" of sub-group (by name pattern)
        if (groups.length > 0) {
            // Deduplicate by a key: for named groups use the name, else use a counter
            const seen = new Set<string>();
            const uniqueGroups: THREE.Object3D[] = [];
            for (const g of groups) {
                // Use the group's name as the kind-key; if unnamed, use index
                const kindKey = g.name || `unnamed_${g.type}`;
                if (!seen.has(kindKey)) {
                    seen.add(kindKey);
                    uniqueGroups.push(g);
                }
            }

            const skipped = groups.length - uniqueGroups.length;
            for (const g of uniqueGroups) {
                lines.push(this.buildSceneGraphSketch(g, childIndent, depth + 1));
            }
            if (skipped > 0) {
                lines.push(`${childIndent}└── ... and ${skipped} more sibling group(s) with same structure`);
            }
        }

        // Tally leaf children (Mesh / LineSegments)
        if (leaves.length > 0) {
            // Separate leaves that have children (need recursion) from pure leaves (tally)
            const withChildren = leaves.filter(c => (c.children?.length ?? 0) > 0);
            const pureLeaves = leaves.filter(c => (c.children?.length ?? 0) === 0);

            // Recurse into leaves that have their own children
            for (const child of withChildren) {
                lines.push(this.buildSceneGraphSketch(child, childIndent, depth + 1));
            }

            // Tally pure leaves
            if (pureLeaves.length > 0) {
                const tally = new Map<string, number>();
                for (const child of pureLeaves) {
                    const label = child.userData?.Type || child.name || child.type;
                    const key = `${label} (${child.type})`;
                    tally.set(key, (tally.get(key) ?? 0) + 1);
                }
                const parts = Array.from(tally.entries()).map(([k, v]) => `${v}× ${k}`);
                lines.push(`${childIndent}├── [ ${parts.join(', ')} ]`);
            }
        }

        return lines.join('\n');
    }

    /** Register a mesh as a structural element without adding it to the THREE group */
    private registerElementFromMesh(mesh: THREE.Mesh, structureCollection: StructureCollection, addToGroup: boolean): GeometricElement | null {
        this.fixElementType(mesh);
        const typeId = mesh.userData?.TypeId;

        // Parity with getMeshesRecursive: recreate the custom material from the
        // raw sRGB values the conversor stamped into userData/extras.
        const savedCustomMaterial = this.buildCustomMaterialFromUserData(mesh);
        let createdElement: GeometricElement | null = null;

        switch (typeId) {
            case ELEMENTSTYPESIDS.PLATE:
            case ELEMENTSTYPESIDS.CONCRETE:
            case ELEMENTSTYPESIDS.BEAMPART:
            case ELEMENTSTYPESIDS.CABLE: {
                const material = GraphicsMaterials.basicMaterial;
                const element = new SurfaceElement(mesh, material, mesh.userData.Guid);
                structureCollection.addSurfaceStructureElement(element, addToGroup);
                createdElement = element;
                break;
            }
            case ELEMENTSTYPESIDS.STIFFENER: {
                const element = new LinearElement(mesh, GraphicsMaterials.stiffenerMaterial3d, mesh.userData.Guid);
                structureCollection.addLinearStructureElement(element, addToGroup);
                createdElement = element;
                break;
            }
            case ELEMENTSTYPESIDS.FACEPLATE: {
                const element = new LinearElement(mesh, GraphicsMaterials.flangeMaterial3d, mesh.userData.Guid);
                structureCollection.addLinearStructureElement(element, addToGroup);
                createdElement = element;
                break;
            }
            case ELEMENTSTYPESIDS.BRACKET: {
                const element = new LinearElement(mesh, GraphicsMaterials.bracketMaterial3d, mesh.userData.Guid);
                structureCollection.addLinearStructureElement(element, addToGroup);
                createdElement = element;
                break;
            }
            case ELEMENTSTYPESIDS.BEAM: {
                const element = new LinearElement(mesh, GraphicsMaterials.beamMaterial3d, mesh.userData.Guid);
                structureCollection.addLinearStructureElement(element, addToGroup);
                createdElement = element;
                break;
            }
            case ELEMENTSTYPESIDS.UNDEFINED: {
                // Parity with the old loader path (getMeshesRecursive): UNDEFINED
                // meshes (persisted rulers/cut-plates) are linear, not structural
                // and never receive a custom material (createdElement stays null)
                const element = new LinearElement(mesh, GraphicsMaterials.redMaterial, mesh.userData.Guid);
                structureCollection.addLinearStructureElement(element, addToGroup);
                break;
            }
            default: {
                // Default to surface element
                const element = new SurfaceElement(mesh, GraphicsMaterials.basicMaterial, mesh.userData.Guid || mesh.name);
                structureCollection.addSurfaceStructureElement(element, addToGroup);
                createdElement = element;
                break;
            }
        }

        if (createdElement && savedCustomMaterial) {
            this.applyCustomMaterialToElement(createdElement, savedCustomMaterial);
        }
        return createdElement;
    }

    private getMeshesRecursive(_mesh, structureCollection: StructureCollection): void {
        if (_mesh.type === 'Mesh') {
            this.fixElementType(_mesh);

            // Recreate custom material from raw sRGB values stored in userData
            // (bypasses GLTF material pipeline to avoid color space drift).
            // Falls back to GLTF-baked material if customMaterialData is absent.
            const savedCustomMaterial = this.buildCustomMaterialFromUserData(_mesh);

            // Track created element for post-creation custom material hook (D-06)
            let createdElement: GeometricElement | null = null;

            switch (_mesh.userData.TypeId) {
                case ELEMENTSTYPESIDS.PLATE:
                    this.bbox.expandByObject(_mesh);
                    let material = _mesh.userData.IsRepair != undefined && _mesh.userData.IsRepair &&
                     _mesh.userData.IsExecuted  != undefined && !_mesh.userData.IsExecuted  ? 
                     GraphicsMaterials.hatchingMaterial : GraphicsMaterials.basicMaterial;
                    const surfaceElement = new SurfaceElement(_mesh, material, _mesh.userData.Guid);

                    surfaceElement.isRepair = _mesh.userData.IsRepair != undefined && _mesh.userData.IsRepair? true : false;
                    if(_mesh.userData.IsRepair != undefined && _mesh.userData.IsRepair)
                    {
                        surfaceElement.targetId = _mesh.userData.TargetId;
                        surfaceElement.targetIds = _mesh.userData.TargetIds;
                        const isDoublerGltf = _mesh.userData.IsDoubler === true;
                        if (!_mesh.userData.IsExecuted) {
                            // surfaceElement.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                            // surfaceElement.currentMaterial = GraphicsMaterials.hatchingMaterial;
                            surfaceElement.executedMaterial = isDoublerGltf ? GraphicsMaterials.doublerBasicMaterial : GraphicsMaterials.basicMaterial;
                          } else {
                            surfaceElement.defaultMaterial = isDoublerGltf ? GraphicsMaterials.doublerBasicMaterial : GraphicsMaterials.basicMaterial;
                            surfaceElement.currentMaterial = isDoublerGltf ? GraphicsMaterials.doublerBasicMaterial : GraphicsMaterials.basicMaterial;
                            surfaceElement.executedMaterial = isDoublerGltf ? GraphicsMaterials.doublerBasicMaterial : GraphicsMaterials.basicMaterial;
                          }
                        surfaceElement.setExecutedMaterial(_mesh.userData.IsExecuted);//  != undefined && !_mesh.userData.IsExecuted ? false : true;
                    }

                    structureCollection.addSurfaceStructureElement(surfaceElement);
                    createdElement = surfaceElement;
                    break;
                case ELEMENTSTYPESIDS.STIFFENER:
                    const stiffenerLinearElement = new LinearElement(_mesh, GraphicsMaterials.stiffenerMaterial3d, _mesh.userData.Guid);
                    structureCollection.addLinearStructureElement(stiffenerLinearElement);
                    createdElement = stiffenerLinearElement;
                    break;
                case ELEMENTSTYPESIDS.FACEPLATE:
                    const facePlateLinearElement = new LinearElement(_mesh, GraphicsMaterials.flangeMaterial3d, _mesh.userData.Guid);
                    structureCollection.addLinearStructureElement(facePlateLinearElement);
                    // TODO: temporary solution until the faceplates visualization is fixed
                    // Faceplates are hidden by default for FEA/submodel assets.
                    // They become visible only when the user explicitly selects the FacePlate type in the view-mode-elements panel.
                    const isFea = this.assetInfo.IsCad === false && !!this.assetInfo.LinkedAsset;
                    const isSubmodel = this.assetInfo.IsSubmodel === true && !!this.assetInfo.ParentFeaModelId;
                    if (isFea || isSubmodel) {
                        facePlateLinearElement.SurfaceDesign.visible = false;
                    }
                    createdElement = facePlateLinearElement;
                    break;
                case ELEMENTSTYPESIDS.BRACKET:
                    const bracketLinearElement = new LinearElement(_mesh, GraphicsMaterials.bracketMaterial3d, _mesh.userData.Guid);
                    structureCollection.addLinearStructureElement(bracketLinearElement);
                    createdElement = bracketLinearElement;
                    break;
                case ELEMENTSTYPESIDS.BEAM:
                    const beametLinearElement = new LinearElement(_mesh, GraphicsMaterials.beamMaterial3d, _mesh.userData.Guid);
                    structureCollection.addLinearStructureElement(beametLinearElement);
                    createdElement = beametLinearElement;
                    break;
                case ELEMENTSTYPESIDS.BEAMPART:
                    const beamPartSurfaceElement = new SurfaceElement(_mesh, GraphicsMaterials.basicMaterial, _mesh.userData.Guid);
                    structureCollection.addSurfaceStructureElement(beamPartSurfaceElement);
                    createdElement = beamPartSurfaceElement;
                    break;
                case ELEMENTSTYPESIDS.CABLE:
                    const cableSurfaceElement = new SurfaceElement(_mesh, GraphicsMaterials.basicMaterial, _mesh.userData.Guid);
                    structureCollection.addSurfaceStructureElement(cableSurfaceElement);
                    createdElement = cableSurfaceElement;
                    break;
                case ELEMENTSTYPESIDS.UNDEFINED:
                    const undefinedLinearElement = new LinearElement(_mesh, GraphicsMaterials.redMaterial, _mesh.userData.Guid);
                    structureCollection.addLinearStructureElement(undefinedLinearElement);
                    // UNDEFINED elements use redMaterial — not structural, no custom material support
                    break;
                default:
                    this.bbox.expandByObject(_mesh);
                    // if (structureCollection.regionsWorkableElements.length === 1)
                    {
                        _mesh.userData.RegionId = structureCollection.regionsWorkableElements[0].Guid;
                        _mesh.userData.RegionIds = [structureCollection.regionsWorkableElements[0].Guid];
                        _mesh.userData.SectionID = structureCollection.regionsWorkableElements[0].sections[0].Guid;
                        // _mesh.userData.TypeId = ELEMENTSTYPESIDS.PLATE;

                        if (!_mesh.userData.Guid)
                            _mesh.userData.Guid = uuid() as string;
                        _mesh.name = _mesh.userData.Guid;

                        const _surfaceElement = new SurfaceElement(_mesh, GraphicsMaterials.basicMaterial, _mesh.userData.Guid);
                        structureCollection.addSurfaceStructureElement(_surfaceElement);
                        createdElement = _surfaceElement;
                    }
                    break;
            }

            // Apply custom material after the element constructor assigned its default.
            // Material was either recreated from raw sRGB userData or fell back to GLTF-baked.
            if (createdElement && savedCustomMaterial) {
                this.applyCustomMaterialToElement(createdElement, savedCustomMaterial);
            }
        }
        else if (_mesh.children.length > 0) {
            for (let index = _mesh.children.length - 1; index >= 0; index--) {
                this.getMeshesRecursive(_mesh.children[index], structureCollection);
            }
        }
    }

    /**
     * Recreate the per-element custom material from raw sRGB values stored in
     * userData (bypasses the GLTF material pipeline to avoid color space drift).
     * Returns null when custom materials are disabled (UseDefaultMaterial) or the
     * mesh has none; falls back to the GLTF-baked material when the raw data is absent.
     */
    private buildCustomMaterialFromUserData(mesh: THREE.Mesh): THREE.MeshStandardMaterial | null {
        if (this.assetInfo.UseDefaultMaterial || !mesh.userData.hasCustomMaterial) return null;
        const cmd = mesh.userData.customMaterialData;
        if (!cmd) return mesh.material as THREE.MeshStandardMaterial;
        return new THREE.MeshStandardMaterial({
            color: cmd.Color || '#ffffff',
            opacity: cmd.Opacity != null ? cmd.Opacity : 1.0,
            transparent: (cmd.Opacity != null ? cmd.Opacity : 1.0) < 1.0,
            roughness: cmd.Roughness != null ? cmd.Roughness : 0.85,
            metalness: cmd.Metalness != null ? cmd.Metalness : 0.5,
            side: THREE.DoubleSide,
            envMap: this.graphics.customMaterialEnvMap,
            envMapIntensity: 0.3,
        });
    }

    /** Register a custom material on an element, with the post-creation fixups from D-06. */
    private applyCustomMaterialToElement(element: GeometricElement, material: THREE.MeshStandardMaterial): void {
        material.polygonOffset = true;
        material.polygonOffsetFactor = 1;
        material.polygonOffsetUnits = 1;
        material.side = THREE.DoubleSide;
        material.depthWrite = true;  // GLTFLoader sets false for BLEND; restore to prevent occlusion in multi-element scenes
        element.customMaterial = material;
        element.currentRenderMaterial = material;
    }

    //webworker
    private setSectionGroups(structureCollection: StructureCollection, regionId: string): void {
        const regionInfo = this.assetInfo.Regions.find(x => x.id === regionId);
        const region = new Region(regionInfo.id, regionInfo.name);

        region.isStructural = true;
        for (const sectionId of regionInfo.sections) {
            const sec = this.assetInfo.Sections.find(x => x.id === sectionId);
            const section = new Section(sectionId, sec.name);
            section.isStructureSection = true;
            region.addSection(section);
        }
        structureCollection.group.add(region.group);
        structureCollection.regionsWorkableElements.push(region);
    }

    private fixElementType(element: any): void {
        if (Util.isNullOrUndefined(element.userData.TypeId) || this.assetInfo.HasOverlappedGeometry) {
            switch (element.userData.Type) {
                case 'Plate':
                    element.userData.TypeId = ELEMENTSTYPESIDS.PLATE;
                    break;
                case 'Stiffener':
                    element.userData.TypeId = ELEMENTSTYPESIDS.STIFFENER;
                    break;
                case 'FacePlate':
                    element.userData.TypeId = ELEMENTSTYPESIDS.FACEPLATE;
                    break;
                case 'Bracket':
                    element.userData.TypeId = ELEMENTSTYPESIDS.BRACKET;
                    break;
                case 'BeamPart':
                    element.userData.TypeId = ELEMENTSTYPESIDS.BEAMPART;
                    break;
                case 'Cable':
                    element.userData.TypeId = ELEMENTSTYPESIDS.CABLE;
                    break;
                default:
                    break;
            }
        }
    }

    private createResourceCampaigns(regions: Array<Region>): DocumentsCollection {
        const resourceCampaign: DocumentsCollection = new DocumentsCollection(this.assetManager, this.snackbar);
        for (const region of regions) {
            const resourceRegion = new Region(region.Guid, region.Name);
            for (const section of region.sections) {
                const resourceSection = new Section(section.Guid, section.Name);
                resourceRegion.sections.push(resourceSection);
            }
            resourceCampaign.regionsWorkableElements.push(resourceRegion);
        }
        return resourceCampaign;
    }

    private createSensorCampaign(date: Date, regions: Array<Region>): SensorCollection {
        const resourceCampaign: SensorCollection = new SensorCollection(date);
        for (const region of regions) addCampaignRegion(resourceCampaign, region, { css: true });
        // was: for (const region of regions) {
        // was:     const resourceRegion = new Region(region.Guid, region.Name);
        // was:     for (const section of region.sections) {
        // was:         const resourceSection = new Section(section.Guid, section.Name);
        // was:         resourceRegion.sections.push(resourceSection);
        // was:         resourceRegion.group.add(resourceSection.group);
        // was:         resourceRegion.cssGroup.add(resourceSection.cssGroup);
        // was:     }
        // was:     resourceCampaign.group.add(resourceRegion.group);
        // was:     resourceCampaign.cssGroup.add(resourceRegion.cssGroup);
        // was:     resourceCampaign.regionsWorkableElements.push(resourceRegion);
        // was: }

        return resourceCampaign;
    }

    private createInspectionCampaign(date: Date, regions: Array<Region>): InspectionCampaign {
        const resourceCampaign = new InspectionCampaign(
            this.assetManager.AddCollectionIntegration(
                date,
                null,
                CollectionStaticData.COLLECTION_TYPE_INSPECTION_ID,
                INSERTIONCONSTANTS.POINT,
                INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING,
                "InpectionTypeName",
            ),
            date)
        resourceCampaign.CollectionInfoModel.CollectionId = resourceCampaign.CollectionInfoModel.TempCollectionId;
        resourceCampaign.group.visible = true;
        // const resourceCampaign: InspectionCampaign = new InspectionCampaign(null, date);
        for (const region of regions) addCampaignRegion(resourceCampaign, region, { css: false });
        // was: for (const region of regions) {
        // was:     const resourceRegion = new Region(region.Guid, region.Name);
        // was:     for (const section of region.sections) {
        // was:         const resourceSection = new Section(section.Guid, section.Name);
        // was:         resourceRegion.sections.push(resourceSection);
        // was:         resourceRegion.group.add(resourceSection.group);
        // was:     }
        // was:     resourceCampaign.group.add(resourceRegion.group);
        // was:     resourceCampaign.regionsWorkableElements.push(resourceRegion);
        // was: }

        return resourceCampaign;
    }

    public async createLoaders(): Promise<void> {
        if (Util.isNullOrUndefined(this.manager)) {
            this.manager = new THREE.LoadingManager();
        }

        this.manager.onProgress = (url: string, itemsLoaded: number, itemsTotal: number) => {
            const random = Math.round(Math.random() * 15);
            this.setItemsLoaded(itemsLoaded, itemsTotal);

            const partial = Math.round((itemsLoaded / itemsTotal) * 100) - random;
        };

        if (Util.isNullOrUndefined(this.gltfLoader)) {
            this.gltfLoader = new MaHGLTFLoader(this.manager);
        }

        if (Util.isNullOrUndefined(this.dracoLoader)) {

            this.dracoLoader = new DRACOLoader(this.manager);
            this.dracoLoader.setDecoderPath('/statics/draco/');
            // this.dracoLoader.setDecoderConfig({ type: 'js' });
            this.dracoLoader.setWorkerLimit(6);
            this.dracoLoader.preload();

            this.gltfLoader = this.gltfLoader.setDRACOLoader(this.dracoLoader);
        }

        // Setup meshopt decoder for EXT_meshopt_compression support
        await MeshoptDecoder.ready;
        this.gltfLoader.setMeshoptDecoder(MeshoptDecoder);
    }

    private setItemsLoaded(itemsLoaded: number, itemsTotal: number) {
        this.gltfLoadedTotal = itemsTotal;
        this.gltfLoadedItems = itemsLoaded;
        this.gltfLoadedParts = `${this.gltfLoadedItems}/${this.gltfLoadedTotal}`;
    }

    private extractHexValues(url) {
        const regex = /v1\/([a-fA-F0-9\-]+).*Geometry\/([a-fA-F0-9\-]+)/
        const match = url.match(regex)

        if (match && match.length >= 3) {
            return {
                regionId: match[1],
                sectionId: match[2],
            }
        } else {
            throw new Error('Invalid URL')
        }
    }
}
